<template>
  <div>
    <div class="flex items-center justify-between mt-2">
      <page-header
        heading="Cards "
        breadcrumb="Settings  >>  Payments >>  Card"
      />
  </div>
  <empty-card v-if="isEmpty" />
  <cards v-else />

  </div>
</template>

<script>
import PageHeader from "@/components/Ondemand/PageHeader";
import EmptyCard from "@/components/Ondemand/Payments/EmptyCard.vue";
import Cards from "@/components/Ondemand/Payments/Cards.vue";

export default { 
  components: {
    PageHeader,
    EmptyCard,
    Cards,
  },
  data(){
    return {
      isEmpty: false
    }
  }
};  
</script>

<style></style>
